import DataGridTableSkeleton from "../../../components/skeletons/DataGridTableSkeleton";

export default function PlansListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
